"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Boundable = _interopRequireDefault(require("./Boundable"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _Serializable = _interopRequireDefault(require("../../../../../java/io/Serializable"));

var _Assert = _interopRequireDefault(require("../../util/Assert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AbstractNode =
/*#__PURE__*/
function () {
  function AbstractNode() {
    _classCallCheck(this, AbstractNode);

    AbstractNode.constructor_.apply(this, arguments);
  }

  _createClass(AbstractNode, [{
    key: "getLevel",
    value: function getLevel() {
      return this._level;
    }
  }, {
    key: "size",
    value: function size() {
      return this._childBoundables.size();
    }
  }, {
    key: "getChildBoundables",
    value: function getChildBoundables() {
      return this._childBoundables;
    }
  }, {
    key: "addChildBoundable",
    value: function addChildBoundable(childBoundable) {
      _Assert.default.isTrue(this._bounds === null);

      this._childBoundables.add(childBoundable);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._childBoundables.isEmpty();
    }
  }, {
    key: "getBounds",
    value: function getBounds() {
      if (this._bounds === null) {
        this._bounds = this.computeBounds();
      }

      return this._bounds;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return AbstractNode;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Boundable.default, _Serializable.default];
    }
  }]);

  return AbstractNode;
}();

exports.default = AbstractNode;

AbstractNode.constructor_ = function () {
  this._childBoundables = new _ArrayList.default();
  this._bounds = null;
  this._level = null;

  if (arguments.length === 0) {} else if (arguments.length === 1) {
    var level = arguments[0];
    this._level = level;
  }
};

AbstractNode.serialVersionUID = 6493722185909573708;